/* THIS POPUP IS DEPRECATED AND SHOULD BE REMOVED, THE SAME POPUP IS A PART OF THE Gates MODULE */
// TODO: remove
import styled from 'styled-components';
import React, { useState } from 'react';
import PopUpLine from './PopUpLine';
/* eslint-disable react/jsx-props-no-spreading */

import { SecondGateData } from '../../data/GameDefinitionData';

import {
    WhiteMan as WhiteSource,
    RedMan as RedSource,
    GreenMan as GreenSource,
} from '../../Constants/assets';

// Stylings

const InnerContainer = styled.div`
    width: 500px;
    height: 416px;
    background: ${props => props.theme.colors.white};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    text-align: left;
    position: absolute;
    font-family: 'Roboto', sans-serif;
    z-index: 2;
    animation: zoomIn 0.2s ease-in-out;
    transform: translate(50%, 50%);
`;
const TextContainer = styled.div`
    height: 72%;
    width: 87%;
    margin: 0 auto;
`;
const Br = styled.div`
    height: 9%;
`;
const HeaderText = styled.div`
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    color: ${props => props.theme.colors.black};
    height: 15%;
`;
const ParagraphText = styled.div`
    font-size: 16px;
    line-height: 21.8px;
    color: ${props => props.theme.colors.black};
    width: 85%;
    display: inline-table;
`;
const ButtonContainer = styled.button`
    width: 252px;
    height: 50px;
    background: ${props => props.theme.colors.darkGreen};
    border-radius: 4px;
    cursor: pointer;
    border: none;
    padding-top: 15px;
`;
const ButtonContainerLine = styled.div`
    width: 91.5%;
    height: 25%;
    display: flex;
    justify-content: flex-end;
`;
const GetStartedButton = styled.div`
    font-weight: bold;
    font-size: 16px;
    line-height: 2.05vh;
    color: ${props => props.theme.colors.white};
    width: 100%;
`;

const GateEarning = styled.div``;
// TODO: Fix this, this is temporary fix
export default function GateSecondControlPopUp({
    show,
    toggleSeconGateControl,
    toggleSecondGateNeeded,
    handleGateNumber,
    gateNumber,
    endTurn,
    setOneLessStep,
}) {
    // const [gateNumber, setGateNumber] = useState(1);
    // const handleGateNumber = () => {
    //     setGateNumber(currentGate => currentGate + 1);
    // };
    if (show) {
        return (
            <InnerContainer>
                <Br />
                <TextContainer>
                    <HeaderText> Pass Gate</HeaderText>
                    <ParagraphText>
                        {' '}
                        You were previously delayed at this gate or sent back. You will now pass
                        this gate regardless of the value you have. Bear in mind that if you are
                        short of value it might cause a problem at the next gate. Passing this gate
                        will grant you:
                        <GateEarning>
                            {SecondGateData.map((current, index) => {
                                return (
                                    <PopUpLine key={index} {...current} gateNumber={gateNumber} />
                                );
                            })}
                        </GateEarning>
                        You should now play a special action card.
                    </ParagraphText>
                </TextContainer>
                <ButtonContainerLine>
                    <ButtonContainer
                        onClick={() => {
                            // handleGiveResourcesSeconGateControl();
                            toggleSeconGateControl(false);
                            toggleSecondGateNeeded(false);
                            handleGateNumber(gateNumber + 1);
                            setOneLessStep(false);
                            // endTurn();
                        }}
                    >
                        <GetStartedButton>Play a Special Action Card</GetStartedButton>
                    </ButtonContainer>
                </ButtonContainerLine>
            </InnerContainer>
        );
    }
    return null;
}
